/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { styled } from "styled-components";
import { httpRequest1, httpRequest2 } from "../utils/httpsRequest";
import { UserStoryContext } from "../context/UserStoryState";
import { PrimaryButton } from "./Buttons";
import {
    CardContent,
    Card,
} from "./ui/card";
import {
    ScrollArea
} from "./ui/scroll-area";
const ViewDetailContainer = styled.div``;

const searchPayload = (templateData, formData, page = 1, viewDetailRecordID) => {
    if (page === 0) {
        page = 1;
    }
    if (
        templateData?.tableName !== "" &&
        templateData?.searchComponent.fields.length > 0 &&
        templateData?.tableComponent.tableCol
    ) {
        const payLoad = {
            target: templateData.tableName,
            action: "search",
            filters: {
                logicalOperator: templateData.searchComponent.logicalOperator,
                rules:
                    formData && Object.keys(formData).length > 0
                        ? templateData.searchComponent.fields
                              .map((field) => {
                                  if (formData[field.field]) {
                                      const rule = {
                                          dataType: field.dataType,
                                      };
                                      if (field.foreignTable) {
                                          rule.foreignTable = field.foreignTable;
                                          rule.cfield = field.field;
                                          rule.foreignDataType = field.foreignDataType;
                                          rule.foreignField = field.foreignField;
                                      } else {
                                          rule.field = field.field;
                                      }
                                      if (field.date_from) {
                                          rule.date_from = formData[field.field];
                                      } else if (field.date_to) {
                                          rule.date_to = formData[field.field];
                                      } else {
                                          rule.comparisonOperator = field.comparisonOperator;
                                          rule.value = formData[field.field];
                                      }
                                      return rule;
                                  }
                              })
                              .filter((rule) => rule !== undefined)
                        : [
                              {
                                  field: "recordId",
                                  dataType: "tag",
                                  comparisonOperator: "equals",
                                  value: viewDetailRecordID,
                              },
                          ],
            },
            columnsToRetrieve: [
                {
                    field: "recordId",
                    dataType: "string",
                },
                ...(templateData?.tableComponent?.tableCol.map((item) => {
                    const column = {};
                    if (item.foreignTable) {
                        column.cfield = item.cfield;
                        column.dataType = item.dataType;
                        column.foreignRecordIdDataType = item.foreignRecordIdDataType;
                    } else {
                        column.field = item.field;
                        column.dataType = item.dataType;
                    }
                    if (item.foreignTable) {
                        column.foreignTable = item.foreignTable;
                    }
                    if (item.foreignField) {
                        column.foreignField = item.foreignField;
                    }
                    return column;
                }) || []),
            ],
            resultDisplayOrder: templateData.tableComponent.resultDisplayOrder,
            maxRowsPerPage: templateData.tableComponent.maxRowsPerPage,
            pageToRetrieve: page,
        };
        console.log("created payload", payLoad);
        return payLoad;
    }
};

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

export default function OpCodeViewDetail({
    templateName,
    data,
    changeFrame,
    buttonActive,
    contextField,
    allFrameData,
    setAllFrameData, 
    viewDetailTitle,
}) {
    console.log("viewDetails for multi data", allFrameData);
    const [viewDetails, setViewDetails] = useState({});
    const {
        ResetViewDetailData,
        AddContextData,
        viewDetailTableName,
        viewDetailRecordID,
    } = useContext(UserStoryContext);

    const [template, setTemplate] = useState({
        templateName: "",
        tableName: "",
        viewDetailComponent: {},
    });

    useEffect(() => {
        const getTemplate = async () => {
            await httpRequest2
                .get(`/api/template/${templateName}`)
                .then(async (response) => {
                    if (response.data.length !== 0) {
                        await setTemplate(response.data);
                        console.log("templateName", response.data);
                        if (
                            viewDetailRecordID !== "" &&
                            template?.viewDetailComponent?.fields !== undefined
                        ) {
                            const payLoad = searchPayload(
                                response.data,
                                null,
                                1,
                                viewDetailRecordID,
                            );
                            console.log("viewpayLoad", payLoad);

                            await httpRequest1
                                .post("/BESInsights/search", payLoad)
                                .then((res) => {
                                    console.log("view details", res.data.tableRow[0]);
                                    setViewDetails(res.data.tableRow[0]);
                                })
                                .catch((err) => console.log(err));
                        } else {
                            setViewDetails({});
                        }
                    }
                })
                .catch((err) => console.log(err));
        };

        getTemplate();
    }, [templateName, viewDetailRecordID]);

    useEffect(() => {
        if (Object.keys(viewDetails).length !== 0) {
            // Perform any actions if required when viewDetails change
            sendContextData(data.entityName, contextField);
        }
    }, [viewDetails]);

    function addViewDetails(viewDetails, viewDetailTitle) {
        
        setAllFrameData((prevData) => ({
            ...prevData,
            [viewDetailTitle]: viewDetails,
        }));
    }

    const sendContextData = (tableName, contextField) => {
        const contextFields = contextField;
        let temp = {};
        let mergedData = {};

        for (const item of contextFields) {
            temp[item] = viewDetails[item] || "";
            if (viewDetails[item]) {
                if (item === "recordId") {
                    mergedData[tableName + "_recid"] = viewDetails[item];
                    mergedData[
                        "cc" +
                            tableName.charAt(0).toUpperCase() +
                            tableName.slice(1)
                    ] = viewDetails[item];
                } else {
                    mergedData[item] = viewDetails[item];
                }
            }
        }

        AddContextData(mergedData);
        console.log("Merged data:", mergedData);
    };

    return (
        <ScrollArea className="h-[800px] rounded-md border">
            {/* <div>
            
                {Object.keys(viewDetails).length !== 0 && (
                    <div>
                        <Card>
                            <div className="bg-black text-white p-4 rounded-lg m-2">
                                <h2 className="text-2xl font-bold text-white ">{viewDetailTitle}</h2>
                                <p className="text-muted-foreground text-white">Information of the selected record</p>
                            </div>
                            {template &&
                                template.viewDetailComponent &&
                                template.viewDetailComponent.fields.map((item, index) => (
                                    <CardContent
                                        key={index}
                                        style={item.field === 'recordId' ? { display: 'none' } : {}}
                                    >
                                        <h4 className="bg-gray-100 text-left rounded-[10px] px-1 py-1 mt-1 font-bold text-center">
                                            {item.label}
                                        </h4>
                                        <p className="text-sm px-1 pt-1 text-center" style={{ whiteSpace: "wrap" }}>
                                            {viewDetails[item?.field]}
                                        </p>
                                    </CardContent>
                                ))}
                            <ButtonContainer>
                                <PrimaryButton
                                    $text="Next"
                                    onClick={() => {
                                        changeFrame();
                                        sendContextData(data.entityName, contextField);
                                        ResetViewDetailData();
                                        addViewDetails(viewDetails, viewDetailTitle);
                                    }}
                                />
                            </ButtonContainer>
                        </Card>
                    </div>
                )}
    
                {Object.keys(allFrameData).length !== 0 && (
                    <div>
                        <Card>
                            {Object.entries(allFrameData).map(([title, details], index) => (
                                <React.Fragment key={index}>
                                    <div className="bg-black text-white p-4 rounded-lg m-2">
                                        <h2 className="text-2xl font-bold text-white ">{title}</h2>
                                        <p className="text-muted-foreground text-white">Information of the selected record</p>
                                    </div>
                                    <CardContent>
                                        {Object.entries(details).map(([field, value], idx) => (
                                            <div
                                                key={idx}
                                                style={field === 'recordId' ? { display: 'none' } : {}}
                                            >
                                                <h4 className="bg-gray-100 text-left rounded-[10px] px-2 py-1 mt-3 font-bold text-center">{field}</h4>
                                                <p className="text-sm px-2 pt-2 text-center" style={{ whiteSpace: 'wrap' }}>
                                                    {value}
                                                </p>
                                            </div>
                                        ))}
                                    </CardContent>
                                </React.Fragment>
                            ))}
                        </Card>
                    </div>
                )}
            </div> */}
        </ScrollArea>
    );
    
}
